<template>
    <dl v-if="item.historyCount != 0">
        <dt><button type="button" 
                @click="getHistory()" v-html="$i18nUtil.trans('message.HistoryDetail.001','{cnt}개의 히스토리', {cnt: item.historyCount > 100 ? '100' : item.historyCount})">
                <!-- <b>{{item.historyCount > 100 ? '100' : item.historyCount}}</b>개의 히스토리 -->
            </button>
        </dt>
        <dd>
            <ul>
                <li v-for="idx in histroyDetailLength" :key="'histroyDetail_'+idx">
                    <div  v-if="historyDetail[idx-1].workItem == 'CREATED'" class="status created">{{historyDetail[idx-1].workItem}}</div>
                    <div  v-if="historyDetail[idx-1].workItem != 'CREATED'" class="status updated">UPDATE</div> 
                    <div class="tit">{{historyDetail[idx-1].workKbnName}} {{historyDetail[idx-1].workItemName}}</div>
                    <div class="date">{{historyDetail[idx-1].historyDay}}</div>
                    <div class="name">
                        {{defaultLanguage.indexOf('ko') != -1 ? historyDetail[idx-1].regUserName 
                                                              : historyDetail[idx-1].regUserNameEn != null ? historyDetail[idx-1].regUserNameEn : historyDetail[idx-1].regUserName}}
                    </div>
                </li>
            </ul>
        </dd>
    </dl>
</template>
<script> 
import { mapState, mapActions, mapGetters, mapMutations } from "vuex"; 
import axios from 'axios';
import Vue from 'vue';
export default {
    props:["paperId","groupId","item"],
    data(){
        return {
            historyDetail:[],
            histroyDetailLength:0, 

            defaultLanguage : localStorage.getItem("defaultLanguage") || 'ko'
        }
    }, 
    watch:{  },
    methods:{
        ...mapActions("restAction", ["COWORK_REST_SIMPLE_ACTION"]),
        getHistory(){
            
            if(this.item.historyCount == 0){

			}else{ 
                event.target.parentElement.classList.toggle('active'); 
                if(event.target.parentElement.classList.length== 1){
                
                let obj = this;
                let reqData = {};
                reqData.params ={
                    groupId:this.groupId,
                    paperId:this.item.paperId,   // 페이퍼 ID
                    historyId:this.item.historyId,  // 히스토리ID
                    historyDay:this.$moment(this.item.historyDate).format('YYYY-MM-DD') // 년월일 붙여서 20201026
                } 
                reqData.req = obj.req;
                reqData.url = "/api/copaper/history/getHistoryListByHistoryDay";
                reqData.method = "post";
                obj
                .COWORK_REST_SIMPLE_ACTION(reqData)
                .then(res => {  
                    this.historyDetail = res.result.historyList;
                    this.histroyDetailLength = this.historyDetail.length > 100 ? 100 : this.historyDetail.length;   
                })
                .catch(function(err) {
                console.log(err);
                });
            } else{
                //this.historyDetail=[];
            } 
            } 
        },
    }
}
</script>


// WEBPACK FOOTER //
// src/components/cowork/general/project/detail/tab/history/HistoryDetail.vue